import script from "./MGButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGButton.vue?vue&type=script&setup=true&lang=ts"

import "./MGButton.vue?vue&type=style&index=0&id=5c6905d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c6905d8"]])

export default __exports__